import { ModalState } from '../../shared/models/modal';
import { ModalAction, ModalActions } from '../actions/modal.action';

const initialState: ModalState = {
  name: null,
  data: null,
};

const modalReducer = (state: ModalState = initialState, action: ModalAction): ModalState => {
  switch (action.type) {
    case ModalActions.OpenModal:
      return {
        name: action.name,
        data: action.data,
      };
    case ModalActions.CloseModal:
      return {
        name: null,
        data: null,
      };
    default:
      return state;
  }
};

export default modalReducer;